<template>
  <div class="main-setting-menu">
    <HeaderMenu :title="title" :routeBackName="routeBackName" />

    <div style="overflow: auto; padding-bottom: 20px">
      <div v-if="shortcutsList.length > 0" v-version.up="23">
        <div class="title" style="padding-top: 10px">
          {{ $t("customShortcuts.menuHeader") }}
        </div>
        <div class="underline-separate"></div>
        <ul class="list-main-setting list-menu">
          <li v-for="short in shortcutsList" class="shortcut-list-item">
            <shortcutMenuItem
              :item="short"
              @remove="removeShortcut"
              @save="saveShortcut"
            />
          </li>
        </ul>
        <div class="underline-separate"></div>
      </div>
      <div class="title" style="padding-top: 10px">
        {{ $t("shortcuts.menuHeader") }}
      </div>
      <div class="title" style="padding-top: 10px">
        {{ $t("shortcuts.inBook") }}
      </div>
      <div class="underline-separate"></div>
      <div class="line flex-r">
        <div class="right">+ -</div>
        <div class="left">{{ $t("shortcuts.zoom") }}</div>
      </div>
      <div class="line flex-r">
        <div class="right">CTRL+P</div>
        <div class="left">{{ $t("shortcuts.print") }}</div>
      </div>
      <div class="line flex-r">
        <div class="right">CTRL+O</div>
        <div class="left">{{ $t("shortcuts.togglePagesPanel") }}</div>
      </div>
      <div class="line flex-r">
        <div class="right">CTRL+B</div>
        <div class="left">{{ $t("shortcuts.pinUnpinTab") }}</div>
      </div>
      <div class="line flex-r">
        <div class="right">CTRL+N</div>
        <div class="left">{{ $t("tabs.openNewTab") }}</div>
      </div>
      <div class="line flex-r">
        <div class="right">CTRL+S</div>
        <div class="left">{{ $t("shortcuts.saveDesktop") }}</div>
      </div>
      <div class="line flex-r">
        <div class="right">CTRL+F</div>
        <div class="left">{{ $t("shortcuts.doFS") }}</div>
      </div>
      <div class="line flex-r">
        <div class="right">CTRL+T</div>
        <div class="left">{{ $t("shortcuts.opeRecentBooks") }}</div>
      </div>
      <div class="line flex-r">
        <div class="right">CTRL+G</div>
        <div class="left">{{ $t("shortcuts.goToPage") }}</div>
      </div>

      <div class="line flex-r">
        <div class="right">{{ $t("shortcuts.space") }}</div>
        <div class="left">{{ $t("shortcuts.moveInPage") }}</div>
      </div>

      <div class="line flex-r">
        <div class="right">{{ $t("shortcuts.rightLeftArrows") }}</div>
        <div class="left">{{ $t("shortcuts.navInPages") }}</div>
      </div>

      <div class="line flex-r">
        <div class="right">{{ $t("shortcuts.arrowsUpDown") }}</div>
        <div class="left">{{ $t("shortcuts.navResults") }}</div>
      </div>

      <div class="line flex-r">
        <div class="right">{{ $t("shortcuts.zoomPercent") }}</div>
        <div class="left">{{ $t("shortcuts.zoomOpen") }}</div>
      </div>

      <div class="line flex-r">
        <div class="right">F11</div>
        <div class="left">{{ $t("shortcuts.fullScreen") }}</div>
      </div>

      <div class="line flex-r">
        <div class="right">ESC</div>
        <div class="left">{{ $t("shortcuts.exitFullScreen") }}</div>
      </div>

      <div class="line flex-r">
        <div class="right last">SHIFT+ TAB</div>
        <div class="left last">{{ $t("shortcuts.navTabs") }}</div>
      </div>
      <div class="line flex-r">
        <div class="right last">SHIFT+TAB+CTRL</div>
        <div class="left last">{{ $t("shortcuts.navTabsToLeft") }}</div>
      </div>
      <div class="underline-separate"></div>
      <div class="title">{{ $t("shortcuts.inBookList") }}</div>
      <div class="underline-separate"></div>

      <div class="line flex-r">
        <div class="right">ENTER</div>
        <div class="left">{{ $t("shortcuts.opensWinBook") }}</div>
      </div>

      <div class="line flex-r">
        <div class="right">{{ $t("shortcuts.space") }}</div>
        <div class="left">{{ $t("shortcuts.selectBook") }}</div>
      </div>

      <div class="line flex-r">
        <div class="right">{{ $t("shortcuts.arrowsUpDown") }}</div>
        <div class="left">{{ $t("shortcuts.navBookList") }}</div>
      </div>
      <div class="line flex-r">
        <div class="right">PageDown PageUP</div>
        <div class="left">{{ $t("shortcuts.pageMove") }}</div>
      </div>

      <div class="line flex-r">
        <div class="right">{{ "CTRL +" + $t("shortcuts.mouseClick") }}</div>
        <div class="left">{{ $t("shortcuts.openBookInSepWin") }}</div>
      </div>

      <div class="line flex-r">
        <div class="right last">+ -</div>
        <div class="left last">{{ $t("shortcuts.volumesToggle") }}</div>
      </div>

      <div class="underline-separate"></div>
      <div class="title">{{ $t("shortcuts.general") }}</div>
      <div class="underline-separate"></div>

      <div class="line flex-r">
        <div class="right">F1</div>
        <div class="left">{{ $t("shortcuts.searchBookById") }}</div>
      </div>

      <div class="line flex-r">
        <div class="right">F2</div>
        <div class="left">{{ $t("shortcuts.focusBookInput") }}</div>
      </div>

      <div class="line flex-r">
        <div class="right">F3</div>
        <div class="left">{{ $t("shortcuts.focusFSInput") }}</div>
      </div>

      <div class="line flex-r">
        <div class="right last">TAB</div>
        <div class="left last">{{ $t("shortcuts.toggleFocus") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import KeyboardShortcutService from "@/services/keyboardShortcutService";
import shortcutMenuItem from "@/components/book/shortcutMenuItem.vue";
export default {
  components: {
    shortcutMenuItem,
  },
  data() {
    return {
      // title: ,
      routeBackName: "settings",
      iconV: "3",
      showFileExplore: false,
      resolveLocationSelected: null,
      showRestorePopup: false,
      backupProgress: null,
    };
  },

  created() {},

  methods: {
    async saveShortcut(short, newText, realChar) {
      let charCode = KeyboardShortcutService.cleanCode(realChar);
      let oldComb = short.short.toLowerCase() + short.realChar;
      let newComb = short.short.toLowerCase() + charCode;
      if (oldComb == newComb) return;
      if (KeyboardShortcutService.checkIfShortcutExists(newComb)) {
        let payload = {
          title: this.$t("customShortcuts.exists"),
          content: this.$t("customShortcuts.replaceExistingShortcut"),
          btns: [this.$t("general.yes"), this.$t("general.no")],
        };
        let act = await this.$msg(payload);
        if (act != this.$t("general.yes")) return;
      }
      let succeeded = KeyboardShortcutService.editShortcutInSettings(
        oldComb,
        newComb
      );
      let msg = this.$t(
        succeeded
          ? "customShortcuts.successfullyUpdated"
          : "customShortcuts.error"
      );
      const notification = {
        type: succeeded ? "success" : "error",
        message: msg,
        timeout: 2000,
      };
      this.$notify(notification);
    },
    async removeShortcut(short) {
      let succeeded = KeyboardShortcutService.removeShortcutFromSettings(
        short.short.toLowerCase() + short.realChar
      );
      const notification = {
        type: succeeded ? "success" : "error",
        message: this.$t(
          succeeded
            ? "customShortcuts.successfullyDeleted"
            : "customShortcuts.error"
        ),
        timeout: 2000,
      };
      this.$notify(notification);
    },
  },
  computed: {
    title() {
      return this.$t("shortcutKeysMenu.title");
    },
    shortcutsList() {
      return KeyboardShortcutService.getShortcutsList();
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.main-setting-menu {
  width: -webkit-fill-available;
  z-index: 3;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.list-main-setting {
  display: flex;
  flex-direction: column;
  // margin: 0;
  // padding: 0;
  list-style-type: none;
}
.item {
  display: flex;
  align-items: center;
  height: 30px;
  padding: 0 20px;
}

.list-menu .item.item-btn {
  margin: 0;
  padding: 0 25px 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #000;
  .btn.btn-row-item {
    margin: 0;
  }
}
.location-class {
  font-size: 11px;
  color: #000;
  line-height: 17px;
  max-width: 220px;
  padding-right: 20px;
}
.last-backup {
  display: flex;
  color: #000;
  padding: 0 20px;
}
.text-en-left {
  text-align: right;
}
.right {
  border-right: gray solid 1px;
  border-top: gray solid 1px;
  width: 40%;
  padding-right: 5px;
  padding-left: 5px;
}
.left {
  border-right: gray solid 1px;
  border-left: gray solid 1px;
  border-top: gray solid 1px;
  width: 40%;
  padding-right: 5px;
  padding-left: 5px;
}
.last {
  border-bottom: gray solid 1px;
}
.line {
  display: flex;
  justify-content: center;
}
.title {
  font-size: 13px;
  color: #7f7f7f;
  padding: 0px 20px;
}
.shortcut-list-item {
  padding-left: 5px !important;
}
</style>
